// extracted by mini-css-extract-plugin
module.exports = {"navToggleGroup":"navtogglegroup_navToggleGroup__3S-fq","roundedSelector":"navtogglegroup_roundedSelector__3NCkM"};